import React, {useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import UIFileType from "./UIFileType"
import styles from "./UIMessageCenterFile.module.scss";
import {getClassNameByType} from "../../../filePage/File/UtilFileCard";
import classNames from "classnames";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileDownload} from "@fortawesome/free-solid-svg-icons";

function UIMessageCenterFile(props: any) {
  const refProgress: any = useRef(false);
  const refLoadingProgress: any = useRef(false);
  const isAnother: any = props.isAnother;
  const fileDetails: any = props?.messageDetails?.fileDetails?.[0];
  const fileDetailsLocal: any = props?.messageURLlocal?.fileDetails?.[0];
  const fileTypeLocal: any = props?.messageURLlocal?.fileType;
  const fileNameLocal: any = props?.messageURLlocal?.fileName;
  let percent: any = {};
  const { t } = useTranslation();
  const fileServiceDownloadURL: any =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";
  
  useEffect(() => {
    if (!fileDetails?.id && props?.uploadProgress?.length === 0)
      refLoadingProgress.current.style.display = "block";
    if (!fileDetails?.id && props?.uploadProgress?.length > 0) {
      if (
        props.uploadProgress?.filter(
          (item: any) => item?.tempMsgId === props?.tempMsgId
        ).length > 0
      ) {
        percent = props.uploadProgress?.filter(
          (item: any) => item?.tempMsgId === props?.tempMsgId
        )?.[0];
        refProgress.current.style.width = percent?.progress + "%";
      }
    }
    if (fileDetails?.id) refLoadingProgress.current.style.display = "none";
  }, [props?.uploadProgress, fileDetails]);

  return (
    <div className={isAnother > 1 ? styles.openGraph2 : styles.openGraph1} >
      <div
        className={styles.previewImg}
      >
        <div
          className={styles.myProgress}
          style={{
            display: fileDetails?.id ? "block" : "block",
          }}
        >
          <div className={styles.fileDetails}>
            <div className={classNames(getClassNameByType(fileDetails?.fileType || fileTypeLocal, false, false), styles.fileIconBox)}>
              <UIFileType type={fileDetails?.fileType ||fileTypeLocal } />
            </div>
            <div className={styles.fileName}>{fileNameLocal || fileDetails?.fileName}</div>
            {fileDetails?.id && (
              <div 
                style={{ cursor: 'pointer' }} 
              >
                <a href={`${fileServiceDownloadURL}${fileDetails?.id}`} download className={styles.linkDownload} >
                  <span role="img" aria-label="more" className="anticon anticon-more" style={{ padding:"10px", fontSize: "1.3rem", top: "0px", color: isAnother > 1 ? "#FFF" : "rgb(124, 124, 124)" }}>
                  <FontAwesomeIcon
                    className="font-awesome"
                    icon={faFileDownload}
                    // style={{
                    //   color: "#0f4c82",
                    //   width: "10.8px",
                    //   height: "10.8px",
                    // }}
                  />
                </span>
                </a>
              </div>
            )}
          </div>

          {/* <audio controls>
              <source src={!fileDetails?.id ? fileDetailsLocal : `${fileServiceDownloadURL}${fileDetails?.id}`}></source>
            </audio> */}
          <div ref={refLoadingProgress} className={styles.videoProgress}>
            <div ref={refProgress} className={styles.myBar}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(UIMessageCenterFile);
